import React from "react";
import dayjs from "utils/dateUtils";

import DiffViewer from "components/DiffViewer";
import { Box, Typography, CardContent } from "@material-ui/core";
import { TIME_FORMAT, FULL_DATE_FORMAT } from "constants/dateFormats";

const messages = {
    created: " created user ",
    updated: " updated user ",
    deleted: " deleted user ",
};

function UserCard({ item }) {
    return (
        <Box component={CardContent} display="flex" flexDirection="column">
            <Typography variant="body1" gutterBottom>
                <b>{`${item?.author?.firstname} ${item?.author?.lastname} `}</b>
                {messages[item.event]}
                <b>
                    {item.changes.firstname ? (
                        <DiffViewer
                            old={item?.oldEntity?.firstname}
                            current={item?.entity?.firstname}
                        />
                    ) : (
                        item?.entity?.firstname
                    )}{" "}
                    {item.changes.lastname ? (
                        <DiffViewer
                            old={item?.oldEntity?.lastname}
                            current={item?.entity?.lastname}
                        />
                    ) : (
                        item?.entity?.lastname
                    )}
                </b>
            </Typography>
            <Typography variant="caption" color="textSecondary">
                {item.changes.email ? (
                    <DiffViewer
                        old={item.oldEntity.email}
                        current={item.entity.email}
                    />
                ) : (
                    item.entity.email
                )}
            </Typography>
            {item.entity.skills.join("").length > 0 && (
                <Typography variant="caption" color={"textSecondary"}>
                    <i>
                        <b>Skills: </b>
                        {item.changes.skills ? (
                            <DiffViewer
                                old={item.oldEntity.skills.join("")}
                                current={item.entity.skills.join("")}
                            />
                        ) : (
                            item.entity.skills
                        )}
                    </i>
                </Typography>
            )}
            {item.event === "created" && (
                <Typography variant="caption" color="textSecondary">
                    <i>
                        Created at:{" "}
                        {dayjs(item.entity.created_at).format(
                            `${FULL_DATE_FORMAT} ${TIME_FORMAT}`
                        )}
                    </i>
                </Typography>
            )}
            {item.event === "updated" && (
                <Typography variant="caption" color="textSecondary">
                    <i>
                        Updated at:{" "}
                        {dayjs(item.entity.updated_at).format(
                            `${FULL_DATE_FORMAT} ${TIME_FORMAT}`
                        )}
                    </i>
                </Typography>
            )}
        </Box>
    );
}

export default UserCard;
